import type { FC } from "react";
import { memo } from "react";

import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import type {
    IntentSignalEventDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";
import {
    isIntentSignalCompanyEvent,
    isIntentSignalDomainsEvent,
} from "app/pages/sales-intelligence/modules/company-analysis/types/signals";

import IntentTopicsList from "../../IntentTopicsList/IntentTopicsList";

import IntentSignalDomainsEventInfo from "./IntentSignalDomainsEventInfo/IntentSignalDomainsEventInfo";

type Props = {
    signal: IntentSignalEventDto;
};

const IntentSignalEventInfo: FC<Props> = ({ signal }) => {
    const onTrackedMouseEnter = (): void => {
        companyAnalysisTrackingService.signalEvents.trackHoverIntentTrend();
    };

    if (isIntentSignalCompanyEvent(signal)) {
        return (
            <IntentTopicsList
                signalEvents={signal.events}
                onMouseEnter={onTrackedMouseEnter}
            />
        );
    }

    if (isIntentSignalDomainsEvent(signal)) {
        return (
            <IntentSignalDomainsEventInfo
                signal={signal}
                onMouseEnter={onTrackedMouseEnter}
            />
        );
    }

    return null;
};

export default memo(IntentSignalEventInfo);
